exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centerImg{\n  text-align: center;\n}\n\n.textImgCenter{\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\ndiv .row{\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.marginBottomS{\n  margin-bottom: 10px;\n}\n\n.marginTopS{\n  margin-top: 10px;\n}\n\n@media only screen and (min-height: 601px){\n  .justify{\n    text-align: justify;\n    padding-top: 40px;\n  }\n}\n\n.row-images {\n   display:-ms-flexbox;\n   display:flex;\n   -ms-flex-pack:center;\n       justify-content:center;\n  margin: 20px 0 30px;\n }\n\n.row-images img {\n  margin: 0px 10px;\n}\n\n.responsive-img-same-height{\n  height: 50vh;\n}\n\n.responsive-img-width-50{\n  max-width: 50%;\n}\n\n.step {\n  font-size: 2rem;\n  font-weight: bold;\n  color: rgba(80,80,80,0.1);\n}\n\n.grey-bg {\n  background-color: rgba(80,80,80,0.1);\n  padding: 30px;\n}\n\n.steps i {\n  font-size:18px;\n}\n\n.examen-steps li {\n  margin-top: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/yoann/Perso/Pedicure-Podologue/src/app/podologie/podologie.component.css
// module id = ../../../../../src/app/podologie/podologie.component.css
// module chunks = 1